module.exports = __webpack_public_path__ + "media/dogs/dog-digging-tail-wag-dd3bf708.svg";